import type { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import {
  ApprovalCol,
  EmailCol,
  FinalPayCol,
  NoteCol,
  SelectCol,
  StatusCol,
  TechnicianCol,
} from "./cols";
import { usePacksSection } from "./packs-section";
import type { PayrollStatementNotificationRecipient } from "./types";

export const useRecipientColumns = () => {
  const {
    awaitingReplyTechnicianIds,
    previewOnly,
    selectedRecipientIds,
    eligibleRecipients,
    allEligibleSelected,
    someEligibleSelected,
    toggleRecipient,
    toggleAllEligible,
    noteDrafts,
    isProjectionBuilding,
  } = usePacksSection();

  return useMemo<ColumnDef<PayrollStatementNotificationRecipient, unknown>[]>(
    () => [
      SelectCol({
        disabled: previewOnly,
        selectedRecipientIds,
        allEligibleSelected,
        someEligibleSelected,
        eligibleRecipientsCount: eligibleRecipients.length,
        onToggleAllEligible: toggleAllEligible,
        onToggleRecipient: toggleRecipient,
      }),
      TechnicianCol(awaitingReplyTechnicianIds),
      EmailCol(),
      FinalPayCol({ isBuilding: isProjectionBuilding }),
      ...(previewOnly ? [] : [ApprovalCol()]),
      StatusCol(),
      NoteCol({ noteDrafts }),
    ],
    [
      selectedRecipientIds,
      allEligibleSelected,
      someEligibleSelected,
      eligibleRecipients.length,
      noteDrafts,
      previewOnly,
      isProjectionBuilding,
      awaitingReplyTechnicianIds,
      toggleAllEligible,
      toggleRecipient,
    ],
  );
};
